export default {
    SUM: "SUM",
    WEIGHTED_AVERAGE: "W_AVG",
    AVERAGE: "AVG",
    NONE: "NONE",
    COUNT_DISTINCT: "COUNT_DISTINCT",
    MOST_COMMON: "MOST_COMMON",
    MIN: "MIN",
    MAX: "MAX",
};
